<template>
  <label :for="forName">
    <slot name="content" />
  </label>
</template>

<script>
export default {
  name: "DsLabel",
  props: {
    forName: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

label {
  display: block;
  text-transform: uppercase;
  color: $mega-dark-gray-color;
  margin-bottom: 4px;
  @include fluid-font($font-small-size);
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-label.vue